import request from '@/router/axios';

function toBladePageParams(params = {}) {
  const p = { ...params };
  if (p.page != null) {
    p.current = p.page;
    delete p.page;
  }
  return p;
}

export const getList = (params) => request({
  url: '/api/produce/front-lift-execution/page',
  method: 'get',
  params: toBladePageParams(params),
});

export const getDetail = (id) => request({
  url: '/api/produce/front-lift-execution/detail',
  method: 'get',
  params: { id },
});

export const selectContracts = (params) => request({
  url: '/api/produce/front-lift-execution/contract-options',
  method: 'get',
  params,
});

export const add = (data) => request({
  url: '/api/produce/front-lift-execution/add',
  method: 'post',
  data,
});

export const update = (data) => request({
  url: '/api/produce/front-lift-execution/update',
  method: 'post',
  data,
});

export const voidRecord = (data) => request({
  url: '/api/produce/front-lift-execution/void',
  method: 'post',
  data,
});

export const getLogs = (id) => request({
  url: '/api/produce/front-lift-execution/logs',
  method: 'get',
  params: { id },
});

export const exportExcel = (data) => request({
  url: '/api/produce/front-lift-execution/export',
  method: 'post',
  data,
  responseType: 'blob',
});
